import styles from './Home.module.css'
import './Home.module.css'
import { useTranslation } from 'react-i18next';

import React, { useEffect } from 'react'
import SeoHelmet from '../../components/SeoHelmet';
import Button from '../../components/shared/Button';
import { ReactComponent as IconArrowDown } from '../../components/shared/icons/arrow_down.svg';

export default function Home() {

  const { t} = useTranslation(); // not passing any namespace will use the defaultNS (by default set to 'translation')

  useEffect(() => {
    const prefetch = () => {
      import('../digital-solutions/DigitalSolutions');
      import('../about/About');
      import('../articles/Articles');
    };
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(prefetch, { timeout: 2000 });
      return () => window.cancelIdleCallback?.(id);
    }
    const timer = setTimeout(prefetch, 1500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className={styles.page}>
      <SeoHelmet description="Soluciones digitales gratuitas y basadas en evidencia para adolescentes con dolor crónico y sus familias." path="/" />
      {/*Section 1*/}
      <div className={"row mx-0 " + styles.row_1_container}>
        <div className={"col-md-6"}>
          <div className={styles.row1_column1_container}>
            <h1 className={styles.home_title}>
            {t('homePage.section1.title')}
            </h1>
            <p className={styles.home_description}>
              {t('homePage.section1.subtitle')}
            </p>

            <div className="row">

                <div className="col d-grid gap-2 d-sm-flex justify-content-sm-center">
                  <Button variant="primary" href="#nuestra-app" iconRight={<IconArrowDown aria-hidden="true" />}>{t('homePage.section1.button1_text')}</Button>
                </div>

              <Button variant="secondary" to="/digital-solutions" className="col-auto">
                {t('homePage.section1.button2_text')}
              </Button>
            </div>

          </div>

        </div>

        <div className={styles.row1_section2 + " col-md-6"}>
          <img className={styles.row1_section2_image} src="/im_home_welcome.webp" alt='Adolescente sonriente, bienvenida a Digital SPA' width="688" height="844" />
        </div>
      </div>


      {/*Section 2*/}
      <div id="nuestra-app" className={styles.row2_container + " mx-0 row"}>
        <div className={styles.section_column1 + " col-md-6"}>
          <div className={styles.section_text_column + " column"}>
            <div className={styles.section_public}>{t('homePage.section2.audience')}</div>
            <h2 className={styles.section_title}>{t('homePage.section2.title')}</h2>
            <div className={styles.section_divider}/>
            <div className={styles.section_subtitle}>{t('homePage.section2.subtitle')}</div>
            <div className={styles.section_button}>
              <Button variant="link-arrow" to="/digital-solutions#adolescentes">{t('generic.know_more')}</Button>
            </div>
          </div>
        </div>
        <div className={styles.section_column2 + " col-md-6"}>
          <img src="/im_section2.webp" alt='Adolescente usando la app Digital SPA en su móvil' loading="lazy" width="682" height="519" />
        </div>
      </div>

      {/*Section 3*/}
      <div className={styles.row2_container + " mx-0 row"}>

        <div className={styles.section_column2 + " col-md-6 order-md-last"}>
          <div className={styles.section_text_column + " column"}>
            <div className={styles.section_public}>{t('homePage.section3.audience')}</div>
            <h2 className={styles.section_title}>{t('homePage.section3.title')}</h2>
            <div className={styles.section_divider}/>
            <div className={styles.section_subtitle}>{t('homePage.section3.subtitle')}</div>
            <div className={styles.section_button}>
              <Button variant="link-arrow" to="/digital-solutions#familias">{t('generic.know_more')}</Button>
            </div>
          </div>
        </div>

        <div className={styles.section_column1 + " col-md-6 order-md-first"}>
          <img src="/im_section3.webp" alt='Familia acompañando a un adolescente con dolor crónico' loading="lazy" width="1318" height="1104" />
        </div>
      </div>

      {/*Section 4 - Profesionals*/}
      <div className={styles.row2_container + " mx-0 row"}>
        <div className={styles.section_column1 + " col-md-6"}>
          <div className={styles.section_text_column + " column"}>
            <div className={styles.section_public}>{t('homePage.section4.audience')}</div>
            <h2 className={styles.section_title}>{t('homePage.section4.title')}</h2>
            <div className={styles.section_divider}/>
            <div className={styles.section_subtitle}>{t('homePage.section4.subtitle')}</div>
            <div className={styles.section_button}>
              <Button variant="link-arrow" to="/articles">{t('generic.know_more')}</Button>
            </div>
          </div>
        </div>
        <div className={styles.section_column2 + " col-md-6"}>
          <img className={styles.rounded_image} src="/im_section4.webp" alt='Profesionales sanitarios revisando publicaciones científicas' loading="lazy" width="600" height="600"  />
        </div>
      </div>


      {/*Section 5 - Entities */}
      <div className={styles.entities_section_container} >
        <h2 className={styles.section_title}>{t('homePage.section5.title')}</h2>
        <div className={styles.entities_subsection_title_container + " row"}>
          <div className={styles.entities_section_divider + " col"}/>
          <h3 className={styles.entities_section_subsection_title + " col"}>{t('homePage.section5.hospital_centers')}</h3>
          <div className={styles.entities_section_divider + " col"}/>
        </div>

        <div className={styles.entities_section_images_container}>
          <div className={styles.entites_image_container}>
            <img src="/hosp_malaga.webp" alt='Hospital Regional Universitario de Málaga' loading="lazy" width="641" height="250"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/hosp_paz.webp" alt='Hospital Universitario La Paz' loading="lazy" width="500" height="200"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/hosp_sant_joan.webp" alt='Hospital Universitari Sant Joan de Reus' loading="lazy" width="740" height="400"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/hosp_santa_lucia.webp" alt='Hospital General Universitario Santa Lucía' loading="lazy" width="282" height="159"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/hosp_torre.webp" alt='Hospital Universitario Torrecárdenas' loading="lazy" width="470" height="90"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/hosp_virgen.webp" alt='Hospital Universitario Virgen de las Nieves' loading="lazy" width="581" height="224"/>
          </div>
        </div>
        <div className={styles.entities_international_subsection_title_container + " row"}>
          <div className={styles.entities_section_divider + " col"}/>
          <h3 className={styles.entities_section_subsection_title + " col"}>{t('homePage.section5.international_colaborators')}</h3>
          <div className={styles.entities_section_divider + " col"}/>
        </div>
        <div className={styles.entities_section_images_container}>
          <div className={styles.entites_image_container}>
            <img src="/hosp_seattle.webp" alt="Seattle Children's Hospital" loading="lazy" width="550" height="290"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/kalorinska_institutet.webp" alt='Karolinska Institutet' loading="lazy" width="700" height="300"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/wro_entity.webp" alt='Universidad de Wrocław' loading="lazy" width="750" height="275"/>
          </div>
          <div className={styles.entites_image_container}>
            <img src="/urv.webp" alt='Universitat Rovira i Virgili' loading="lazy" width="720" height="250"/>
          </div>
        </div>
      </div>

      {/*Section 6 - Who we are */}
      <div className={styles.about_us_section_container + " mx-0 row"} >
        <div className={styles.section_column1 + " col-md-6"}>
          <div className={styles.section_text_column + " col"}>
            <h2 className={styles.section_title}>{t('homePage.section6.title')}</h2>
            <div className={styles.section_divider}/>
            <div className={styles.section_subtitle}>{t('homePage.section6.subtitle')}</div>
            <div className={styles.section_button}>
              <Button variant="link-arrow" to="/about">{t('generic.know_more')}</Button>
            </div>
          </div>
        </div>
        <div className={styles.section_column2 + " col-md-6"}>
          <img className={styles.about_us_section_image} src="/im_team.webp" alt='Equipo de investigación de Digital SPA' loading="lazy" width="1200" height="761"  />
        </div>
      </div>

      <div className={styles.section7_container + " mx-0 row"}>
        {/*Section 8 - Financied by */}
        <div className={styles.built_by_container + " col-md"} >
          <h2 className={styles.financied_by_title}>{t('homePage.section8.title')}</h2>
          <img className={styles.about_us_section_image} src="/team_entity.webp" alt='Universidad de Málaga' loading="lazy" width="2600" height="800"  />
        </div>

        {/*Section 7 - Financied by */}
        <div className={styles.financied_by_container + " col-md"} >
          <h2 className={styles.financied_by_title}>{t('homePage.section7.title')}</h2>
          <img className={styles.about_us_section_image} src="/im_ministerio.webp" alt='Ministerio de Ciencia, Innovación y Universidades' loading="lazy" width="1015" height="254"  />
          <div className={styles.financied_by_subtitle}>PID2021-122885OA-I00</div>
        </div>
      </div>
    </div>
  )
}
